import classNames from 'classnames';
import React from 'react'
import OutsideClickHandler from 'react-outside-click-handler';
import { useSelector } from 'react-redux';
import { NavLink } from 'react-router-dom';
import { dark_mode } from '../../Utility/constants';

const DropDown = ({ items, display, change, page, ...props }) => {
    const mode = useSelector(state => state.mode)

    const dropDownHolderPage = classNames({
        Dropdown_holder_page: true,
        dark: mode === dark_mode ? true : false
    })

    const networks = useSelector(state => state.networks)
    return (
        page ? <div style={{ display: display ? "block" : "none" }} className={dropDownHolderPage} >
            {
                items.map((ele, i) => {
                    return (
                        <div key={i} style={{ borderBottom: "1px inherit #b3b3b3", }} onClick={() => { change(ele) }} className='item'>
                            <NavLink style={{ left: 0, display: 'flex', alignItems: 'center', textDecoration: 'none', color: mode === dark_mode ? '#fff' : '#EE31AF', fontSize: 22, fontWeight: 700 }} to={ele.url}>
                                <img height={30} style={{ marginRight: "15px", height: 30, width: 30 }} src={ele.img}></img>
                                {ele.name}</NavLink>
                        </div>
                    )
                })
            }
        </div> : <div style={{ display: display ? "block" : "none" }} className='Dropdown_holder'>
            {
                items.map((ele, i) => {
                    return (
                        <div key={i} onClick={() => { change(ele) }} className='item'>
                            {page ? <NavLink style={{ textDecoration: 'none', color: '#EE31AF' }} to={ele.url}>{ele.name}</NavLink> : <p><img src={networks[ele].logo_url}></img>{ele}</p>}
                        </div>
                    )
                })
            }
        </div>

    )
}

export default DropDown